import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import BackendClient, { encodeBody } from "../../BackendClient";
import ApiClient from "../../Client";
import Select from "react-select";
import ReportsDownloadList from "./_list";
import ErrorPage from "./../ErrorPage";
import queryString from "query-string";
import DateFormat from "../../helpers/DateFormat";
import DateRange from "../../Components/DateRange";
import { extendStyles } from "../../helpers/formComponent"
import { Object } from "es6-shim";

const mapStateToProps = ({ identity }) => ({
  identity
});

class ReportsDownload extends Component {
  state = {
    cities: null,
    theatres: null,
    reports: [],
    filters: {
      report: {},
      theatre: {}
    },
    isFetching: true,

    isNoticeVisible: true,
    updateDate: true,
    readForm: false,
    error404: false,
    addFilms: []
  };

  getAuthCookie() {
    const { cookies } = this.props;
    return cookies.get(process.env.REACT_APP_IDENTITY_COOKIE) || "";
  }

  fetchCities() {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(`{cities{id name value:id label:name}}`)
      .then(({ cities }) => cities);
  }

  fetchTheatres(where = null) {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(
        `query($where:TheatreWhereInput!){theatres(where:$where){id name value:id label:name}}`,
        { where }
      )
      .then(({ theatres }) => theatres);
  }

  findTheatreCity(id) {
    const authKey = this.getAuthCookie();
    return ApiClient.setHeader("authKey", authKey)
      .request(
        `query($id:ID!){
          theatre(where:{id:$id}){id city{id}}
        }`,
        { id }
      )
      .then(({ theatre }) => theatre);
  }

  componentDidMount() {
    const { city, theatre, date } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );
    const {
      reports,
      cities,
      filters: { theatreFilter }
    } = this.state;
    const queries = [];

    if (cities === null) {
      queries.push(this.fetchCities().then(cities => ({ cities })));
    }

    if (theatre && !(city && theatreFilter)) {
      this.findTheatreCity(theatre)
        .then(row =>
          Object.assign(
            { date },
            row && row.city ? { city: row.city.id, theatre } : { theatre: null }
          )
        )
        .then(params => this.updateLink(params));
    }

    if (!reports.length && date && theatre) {
      queries.push(
        BackendClient.getReportsByDay({ date, theatre })
          .fetchJson()
          .then(data => ({ reports: data }))
      );
    }

    Promise.all(queries).then(results => {
      let data = results.reduce((prev, res) => Object.assign(prev, res));
      Object.assign(data, { isFetching: false });
      this.setState(data);
    });
  }

  componentDidUpdate() {
    const { city, theatre, date } = queryString.parse(
      this.props.location.search,
      {
        decode: true,
        arrayFormat: "none"
      }
    );

    let { filters: stateFilters, theatres } = this.state;
    const parsedFilters = {};

    if (city) {
      stateFilters.city !== city && Object.assign(parsedFilters, { city });
    } else if (stateFilters.city) {
      Object.assign(parsedFilters, { city: null });
    }

    if (theatre) {
      stateFilters.theatre !== theatre &&
        Object.assign(parsedFilters, { theatre });
    } else if (stateFilters.theatre) {
      Object.assign(parsedFilters, { theatre: null });
    }

    if (date) {
      if (
        !stateFilters.date ||
        DateFormat.ddmmyyyy(stateFilters.date) !== date
      ) {
        const dt = this.strToDate(date);
        dt && Object.assign(parsedFilters, { date: dt });
      }
    } else if (stateFilters.date) {
      Object.assign(parsedFilters, { date: null });
    }

    const hasNewFilters = !!Object.entries(parsedFilters).length;
    const filters = hasNewFilters
      ? Object.assign(stateFilters, parsedFilters)
      : stateFilters;

    if (city && !(stateFilters.city === city && theatres)) {
      this.fetchTheatres({ city: { id: city } })
        .then(theatres => this.setState({ theatres, filters }));
    } else if (hasNewFilters) {
      let reportParams = this.getReportFilters(filters);

      this.setState({ isFetching: true })
      BackendClient.getReportsByDay(reportParams)
        .fetchJson()
        .then(reports => this.setState({ reports, filters, isFetching: false }));
    }
  }

  warningFilms = () => {
    this.setState({
      closeNotice: false
    });
  };

  strToDate = str => {
    let pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
    return new Date(str.replace(pattern, "$3-$2-$1"));
  };

  dateRangeFilterOnChange = ({ startDate }) => {
    this.updateLink({
      date: DateFormat.ddmmyyyy(startDate)
    });
  };

  cityFilterOnChange = city => {
    this.updateLink({ city: (city && city.value) || null, theatre: null });
    this.setState({ theatres: null });
  };

  theatreFilterOnChange = theatre => {
    this.updateLink({ theatre: (theatre && theatre.value) || null });
  };

  getReportFilters = filters => {
    let reportParams = {};
    let { date } = this.getRange();

    if (filters) {
      if (filters.date) {
        reportParams.date = filters.date.ddmmyyyy();
      }
      if (filters.city) {
        reportParams.city = filters.city;
      }
      if (filters.theatre) {
        reportParams.theatre = filters.theatre;
      }
    }

    if (!reportParams.date) {
      reportParams.date = date.ddmmyyyy();
    }

    return reportParams;
  };

  updateLink(newParams) {
    const {
      filters: { date, ...stateFitlers }
    } = this.state;
    const filters = Object.assign({}, stateFitlers);
    const params = Object.assign(filters, newParams);
    if (!params.date && date) {
      Object.assign(params, { date: DateFormat.ddmmyyyy(date) });
    }
    const body = Object.entries(params).reduce(
      (prev, [key, value]) =>
        (value && Object.assign(prev, { [key]: value })) || prev,
      {}
    );
    const stringParams = encodeBody(body);
    this.props.history.push(
      `reports-download${stringParams && "?" + stringParams}`
    );
  }

  getRange() {
    let {
      filters: { date }
    } = this.state;
    if (date) {
      return { date };
    }
    return {
      date: new Date(2018, 4, 1)
    };
  }

  getDate() {
    const { date } = this.getRange();
    return date;
  }

  updateReports = (data) => {
    this.setState({ isFetching: true })
    BackendClient.updateReports(data)
      .fetchJson()
      .then(response => {
        if (response.success) {
          BackendClient.getReportsByDay(this.getReportFilters(this.state.filters))
            .fetchJson()
            .then(reports => this.setState({ reports, isFetching: false }));
        } else {
          this.setState({ isFetching: false })
        }
      });

  }

  findOptionByValue(list, value) {
    if (list && value) {
      for (let idx = 0; idx < list.length; idx++) {
        if (list[idx].value === value) {
          return list[idx];
        }
      }
    }
    return null;
  }

  render() {
    const {
      cities,
      theatres,
      filters,
      reports,
      isFetching
    } = this.state;
    const { date } = this.getRange();
    if (this.state.error404) {
      return <ErrorPage />;
    }
    return (
      <Fragment>
        <h1 className="office-h1">Загрузка отчетов</h1>
        {(!this.state.reports.length &&
          this.state.isNoticeVisible && (
            <div className="notice-block">
              <div className="notice-block__icon">i</div>
              <div className="notice-block__description">
                Перед заполнением отчетов необходимо заполнить расписание
              </div>
              <button
                onClick={() => this.setState({ isNoticeVisible: false })}
                className="notice-block__hide"
              >
                Скрыть
              </button>
            </div>
          )) ||
          ""}
        <div className="office-report">
          <form action="" name="formSumm" className="office-filters">
            <div className="office-filters__half custom-datepicker__group">
              <label
                htmlFor="session-datepicker"
                className="custom-datepicker__label"
              >
                День формирования отчета
              </label>
              <DateRange
                input
                dateBegin={(date && new Date(date)) || null}
                onChange={this.dateRangeFilterOnChange}
                singleDatePicker
                className="custom-datepicker__input"
              />
              <img
                src="/images/icon-calendar.png"
                alt=""
                className="custom-datepicker__icon"
              />
            </div>
            <div style={{ display: "contents" }}>
              <div className="office-filters__half custom-select__group">
                <Select
                  onChange={this.cityFilterOnChange}
                  options={cities || []}
                  value={this.findOptionByValue(cities, filters.city)}
                  className="selectReact"
                  classNamePrefix="selectReact"
                  isClearable
                  placeholder="Начните вводить название города"
                  styles={extendStyles()}
                />
              </div>
              <div className="office-filters__full">
                <Select
                  onChange={this.theatreFilterOnChange}
                  options={theatres || []}
                  value={this.findOptionByValue(theatres, filters.theatre)}
                  className="selectReact"
                  classNamePrefix="selectReact"
                  isDisabled={!filters.city}
                  isClearable
                  placeholder="Начните вводить название кинотеатра"
                  styles={extendStyles()}
                />
              </div>
            </div>
          </form>
          <ReportsDownloadList
            reports={reports}
            updateReports={this.updateReports}
            isFetching={isFetching}
          />
        </div>
      </Fragment>
    );
  }
}

export default withCookies(
  withRouter(connect(mapStateToProps)(ReportsDownload))
);



// WEBPACK FOOTER //
// ./src/containers/download/admin.jsx